import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取验证码
   */
  static getVerifyCode(params) {
    return request({
      url: `store/create/get_sms_code`,
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取图形二维码
   */
  static getCaptcha(phone) {
    return request({
      url: `user/verifyCode/captcha?phone=${phone}`,
      host: config.HOST_MALL,
      returnAll: true
    });
  }

  /**
   * 校验图形二维码
   */
  static getImageCode(params) {
    return request({
      url: `user/verifyCode/checkCaptcha`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 检验卡密是否有效 - 注册店铺验证卡密（已登录会员注册店铺）
   */
  static verifyStoreCard_1(params) {
    return request({
      url: 'store/create/checkMemberCardValid',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 检验卡密是否有效 - 注册店铺验证卡密和验证码（未登录注册店铺）
   */
  static verifyStoreCard_2(params) {
    return request({
      url: 'store/create/check_sms_code',
      host: config.HOST_STORE,
      method: 'post_json',
      header: {
        channel: 'store_web_pc'
      },
      data: params
    });
  }

  /**
   * 检验卡密是否有效 - 注册店铺验证卡密和验证码（未登录注册店铺）
   */
  static verifyStoreCard_3(params) {
    return request({
      url: 'store/create/check_code',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否会员信息不全
   */
  static checkMsgIsFull(cardCode, mode, cardTypeId) {
    const cardTypeIdStr = 'cardTypeId=' + (cardTypeId || 0);
    let url = `user/upgrade/checkUpgradeCompletionInfor/${cardCode}` + `?${cardTypeIdStr}`;
    if (mode) {
      url = `user/upgrade/checkUpgradeCompletionInfor/${cardCode}?mode=99` + `&${cardTypeIdStr}`;
    }
    return request({
      url: url,
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/RegisterStore/RegisterStoreServ.js